import { _ as r } from "./taggedTemplateLiteralLoose-b7a1029e.js";
import "./es.object.assign-7e79fd7b.js";
import { c as m } from "./index-8b07dec9.js";
import O from "react";
import { styled as p, css as n } from "styled-components";
import { getAriaProps as q } from "./aria.js";
import "./es.array.concat-d1c9b847.js";
import "./es.array.is-array-7a29277f.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.to-string-f55666a8.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { a as u } from "./index-5d0f31c6.js";
import { P as w } from "./popupTip-06ee114c.js";
import "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.string.starts-with-a6645e0a.js";
import "./es.string.link-fd2676c6.js";
import { jsxs as _, jsx as e, Fragment as W } from "react/jsx-runtime";
import { Tooltip as k } from "./tooltip.js";
import "./export-cdcbfb2b.js";
import "./object-keys-719a5561.js";
import "./es.array.filter-4e9c9996.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./html-32ef1b46.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./iterate-13ada9e5.js";
import "./classof-21a3574e.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./es.object.entries-d2a19275.js";
import "./es.string.replace-f4cc3aea.js";
import "./function-apply-4756dee6.js";
import "./to-string-92a62764.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./array-method-is-strict-e5a3c878.js";
import "./es.object.keys-9d66766f.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./array-slice-79f93c56.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./set-species-5ede2ed0.js";
import "./es.string.iterator-5de8a61e.js";
import "@ucl/shared-component-foundations";
import "@ucl/shared-icons";
import "./getMetrics-953aa4f8.js";
import "./web.set-timeout-72b6430f.js";
import "./environment-ddee5959.js";
import "./validate-arguments-length-eb516e5b.js";
import "react-dom";
import "./usePopoverIndex.js";
import "./useEventListener.js";
import "./getTarget-19e0f923.js";
import "./isClient-2f5bedbd.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import "./useWindowSize.js";
import "./button.js";
import "./combineRefs-c9ad2c39.js";
import "./divider.js";
import "./focusTrap.js";
import "./es.array.find-index-cbf7640b.js";
import "./es.array.from-fe752fa6.js";
import "./es.array.index-of-084b82ab.js";
import "./useClient.js";
import "./useOnClickOutside.js";
import "./closeButton.js";
import "./iconButton.js";
import "./getElementPosition-8d0dbc61.js";
import "./es.parse-int-d7709701.js";
import "./string-trim-14e37ad3.js";
import "./string-html-forced-a746405b.js";
import "./es.array.join-c1bca812.js";
import "./es.parse-float-020a2ae0.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./es.regexp.to-string-e800d529.js";
import "./uniqueId.js";
import "./es.date.to-string-6ed49878.js";
import "./es.global-this-a7f40ce1.js";
var f, v, h, L, T, g, x, y = p.div(f || (f = r([`
  &.Label__wrapper {
    `, `;
  }
`])), function(t) {
  var o = t.theme.components.label;
  return n(o.Wrapper);
}), R = p.label(v || (v = r([`
  &.Label__text {
    `, `;
  }
`])), function(t) {
  var o = t.theme.components.label;
  return n(o.Text);
}), C = p.span(h || (h = r([`
  &.Label__trailing-text {
    `, `;
  }
`])), function(t) {
  var o = t.theme.components.label;
  return n(o.TrailingText);
}), b = p.div(L || (L = r([`
  &.Label__info-icon {
    `, `;
  }
`])), function(t) {
  var o = t.theme.components.label;
  return n(o.InfoIconWrapper);
}), E = p.span(T || (T = r([`
  &.Label__required-wrapper {
    `, `;
  }
`])), function(t) {
  var o = t.theme.components.label;
  return n(o.RequiredWrapper);
}), F = p.div(g || (g = r([`
  &.Label__trailing-element {
    `, `;
  }
`])), function(t) {
  var o = t.theme.components.label;
  return n(o.TrailingElementWrapper);
}), S = p(u)(x || (x = r([`
  &.Label__success-icon {
    `, `;
  }
`])), function(t) {
  var o = t.theme.components.label;
  return n(o.SuccessIcon);
}), a = function(o) {
  o.stopPropagation();
};
function xt(t) {
  var o = t.labelProp, i = t.infoProp, c = t.trailingText, s = t.trailingElement, N = t.renderAs, j = t.className, d = t.onClick, I = d === void 0 ? a : d, P = (o == null ? void 0 : o.label) || (o == null ? void 0 : o.showRequiredIndicator) || (o == null ? void 0 : o.success) || (i == null ? void 0 : i.infoText) || c, l = q("button", Object.assign({}, i));
  return (P || /* @__PURE__ */ O.isValidElement(s)) && /* @__PURE__ */ _(y, {
    className: m(["Label__wrapper", j]),
    onClick: I,
    onKeyUp: a,
    as: N,
    children: [/* @__PURE__ */ _(R, {
      htmlFor: o == null ? void 0 : o.htmlFor,
      className: "Label__text",
      id: o == null ? void 0 : o.id,
      children: [o == null ? void 0 : o.label, (o == null ? void 0 : o.showRequiredIndicator) && /* @__PURE__ */ e(E, {
        className: m(["Label__required-wrapper", {
          "Label__required-wrapper--required": o.showRequiredIndicator
        }]),
        "aria-hidden": "true",
        children: "*"
      }), (o == null ? void 0 : o.success) && /* @__PURE__ */ e(S, {
        className: "Label__success-icon",
        icon: "checkmark"
      })]
    }), c && /* @__PURE__ */ e(C, {
      className: "Label__trailing-text",
      children: c
    }), s && /* @__PURE__ */ e(F, {
      className: "Label__trailing-element",
      children: s
    }), (i == null ? void 0 : i.infoText) && (i.infoType === "tooltip" ? /* @__PURE__ */ e(k, {
      placement: "auto",
      title: i.infoText,
      className: "Label__tooltip-component",
      children: /* @__PURE__ */ e(b, Object.assign({
        tabIndex: 0
      }, l, {
        "aria-label": l["aria-label"] || i.infoText,
        role: "button",
        className: m(["Label__info-icon", "Label__info-icon--tooltip"]),
        onClick: a,
        children: /* @__PURE__ */ e(u, {
          icon: "information",
          size: "m"
        })
      }))
    }) : i.infoType === "popuptip" ? /* @__PURE__ */ e(b, {
      className: "Label__info-icon",
      onClick: a,
      onFocus: a,
      children: /* @__PURE__ */ e(w, {
        placement: "auto",
        popupTipBody: i == null ? void 0 : i.infoText,
        popupTipHeader: i.popupTipHeader,
        showButton: !1,
        children: /* @__PURE__ */ e(b, Object.assign({
          tabIndex: 0
        }, l, {
          "aria-label": l["aria-label"] || i.infoText,
          role: "button",
          className: m(["Label__info-icon--popuptip"]),
          children: /* @__PURE__ */ e(u, {
            icon: "information",
            size: "m"
          })
        }))
      })
    }) : "")]
  }) || /* @__PURE__ */ e(W, {});
}
export {
  xt as Label
};
